import React, {PureComponent} from "react"
import * as PropTypes from "prop-types"
import styled from "styled-components"

import {connect} from "@irati/store"
import {ReduxState} from "@irati/store/types"
import id from "@irati/utils/id"
import authentication from "@irati/auth"
import {
  PerksLogo,
  AdminLogo,
  CelebrationLogo,
  PerkboxLogo,
  MedicalLogo,
  MobilePerksLogo,
  MobileRecognitionLogo,
  MobileMedicalLogo,
  WellnessLogo,
  MobileWellnessLogo
} from "@irati/ui/src/Logos"
import adminBg from "@irati/ui/images/adminBg.svg"
import media from "@irati/ui/src/global/media"

import {Auth} from "@irati/auth/types"
import HeaderLink from "./HeaderLink"
import {TenantLogo} from "../styled"

const AdminBg = styled.div`
  background-image: url(${adminBg});
  background-position: right;
  width: 140px;
  margin-left: -16px;
  a:hover,
  a:active,
  a:focus {
    background-color: initial;
    box-shadow: none;
  }
`

const StyledPerkboxLogo = styled(PerkboxLogo)`
  margin: 23px 0;
  ${media.tablet`
    margin: 13px 0;
  `}
`

const StyledAdminLogo = styled(AdminLogo)`
  margin: 23px 0 23px 15px;
  ${media.tablet`
    margin: 13px 0 13px 15px;
  `}
`

interface Props {
  id: string
  isMobile: boolean
  auth: Auth
}

class HeaderCurrentApp extends PureComponent<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }

  render() {
    if (!authentication.isLoggedIn()) {
      return null
    }
    const {isMobile, auth} = this.props
    const {branding} = auth
    const {apps, appPath} = this.context

    const idNamespace = id("current-app", this.props)
    const idHome = id("link-home", idNamespace)
    const idAdmin = id("link-admin", idNamespace)
    const idPerks = id("link-perks", idNamespace)
    const idAccount = id("link-account", idNamespace)
    const idRecognition = id("link-recognition", idNamespace)
    const idMedical = id("link-medical", idNamespace)
    const idWellness = id("link-wellness", idNamespace)

    let Logo
    switch (appPath) {
      case apps.HOME:
        return (
          <>
            {isMobile && <TenantLogo src={branding.businessLogoUrl} />}
            {!isMobile && (
              <HeaderLink id={idAccount} to="/" app={apps.HOME}>
                <StyledPerkboxLogo id={id("img", idHome)} />
              </HeaderLink>
            )}
          </>
        )
      case apps.ACCOUNT:
        return (
          <HeaderLink id={idAccount} to="/" app={apps.HOME}>
            <PerkboxLogo id={id("img", idAccount)} />
          </HeaderLink>
        )
      case apps.ADMIN:
        return (
          <AdminBg>
            <StyledAdminLogo id={id("img", idAdmin)} />
          </AdminBg>
        )
      case apps.RECOGNITION:
        Logo = isMobile ? MobileRecognitionLogo : CelebrationLogo
        return (
          <HeaderLink id={idPerks} to="/" app={apps.RECOGNITION}>
            <Logo id={id("img", idRecognition)} />
          </HeaderLink>
        )
      case apps.MEDICAL:
        Logo = isMobile ? MobileMedicalLogo : MedicalLogo
        return (
          <HeaderLink id={idNamespace} to="/" app={apps.MEDICAL}>
            <Logo id={id("img", idMedical)} />
          </HeaderLink>
        )
      case apps.SEARCH:
      case apps.WALLET:
      case apps.PERKS:
        Logo = isMobile ? MobilePerksLogo : PerksLogo
        return (
          <HeaderLink id={idPerks} to="/" app={apps.PERKS}>
            <Logo id={id("img", idPerks)} />
          </HeaderLink>
        )
      case apps.WELLNESS:
        Logo = isMobile ? MobileWellnessLogo : WellnessLogo
        return (
          <HeaderLink id={idNamespace} to="/" app={apps.WELLNESS}>
            <Logo id={id("img", idWellness)} />
          </HeaderLink>
        )
      default:
        return null
    }
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isMobile: mq.lessThan.medium
})

export default connect(mapStateToProps)(HeaderCurrentApp)
